import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectBankFolderContents } from 'scenes/ProjectBank/services/getProjectBankFolderContents.service';
import { loadUsersAndPersonalResourcesByUserIds } from 'store/projectUsers/thunks/loadUsersAndPersonalResourcesByUserIds';
import { uniq } from 'lodash';
import {
  getUnloadedInteractionProjectIds,
  loadProjectBankInteractions,
} from './loadProjectBankInteractions.thunk';

export const loadProjectBankFolderContents = createAsyncThunk(
  'projectBank/loadProjectBankFolderContents',
  async (folderId, { dispatch, getState }) => {
    if (folderId.includes('tilaajavastuu')) {
      return [];
    }
    let nextToken = null;
    const all = [];

    do {
      const page = await getProjectBankFolderContents(folderId, { nextToken });
      const items = page?.items || [];
      all.push(...items);
      nextToken = page?.nextToken || null;
    } while (nextToken);

    if (all.length > 0) {
      // A file whose uploader the API left out (a gallery-only user's view
      // of someone else's photo) names nobody to load.
      const uniqueUserIds = uniq(all.map((fp) => fp.user).filter(Boolean));
      if (uniqueUserIds.length > 0) {
        dispatch(loadUsersAndPersonalResourcesByUserIds(uniqueUserIds));
      }

      // Reactions of the files (chips on the cards / rows): one load per
      // distinct project of this folder (sub-project files included), never
      // repeated in a bank session. Fire-and-forget.
      const projectIds = all.map((fp) =>
        fp.project && typeof fp.project === 'object'
          ? fp.project.id
          : fp.project
      );
      const unseen = getUnloadedInteractionProjectIds(getState(), projectIds);
      if (unseen.length > 0) {
        dispatch(loadProjectBankInteractions(unseen));
      }
    }

    return all;
  }
);
